import {db, uuid} from "../Database.svelte";
import {readable} from "svelte/store";

export default class ServiceRecommendation {
    constructor (item_id) {
        this.item = db.get(item_id)
    }

    static getServiceRecommendationList() {
        let item_list = [];

        return readable(undefined, (set) => {
            db.allDocs({
                startkey: "serviceRecommendation:",
                endkey: "serviceRecommendation:\ufff0",
                include_docs: true,

            }).then((results) => {
                item_list = results.rows.map(r => r.doc);
                set(item_list)
            })

            let changeMonitor = db.changes({
                since: "now",
                live: true,
                include_docs: true,
                filter: "filters/doc_type",
                query_params: {
                    type: 'serviceRecommendation'
                }
            }).on('change', (change) => {
                if (change.deleted) {
                    item_list = item_list.filter(rec => rec._id != change.id);
                } else {
                    let found = false;
                    item_list = item_list.map((rec) => {
                        if (rec._id != change.id) return rec;
                        found = true;
                        return change.doc;
                    });

                    if (!found) item_list.push(change.doc);
                }

                set(item_list)
            })

            return () => {
                changeMonitor.cancel();
            }
        })
    }

    static getServiceRecommendation(item_id) {
        return db.get(item_id);
    }

    static createServiceRecommendation(item) {
        item.item_id = uuid();
        item._id = `serviceRecommendation:${item.item_id}`;
        item.type = 'serviceRecommendation';

        return db.put(item);
    }

    static saveServiceRecommendation(item) {
        return db.put(item);
    }

    static deleteServiceRecommendation(item) {
        item._deleted = true;
        return db.put(item);
    }
}